<template>
    <div id="bon_cadeau" class="popin-modal centered" v-bind:class="{ 'active': isPopinLoaded }"
        v-show="isPopinDisplayed" v-observe-visibility="{ callback: popin_boncadeauDisplayed_callback }">
        <div class="popin-container">
            <div class="popin-closure" v-on:click="popin_boncadeauClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin-closure-responsive" v-on:click="popin_boncadeauClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin">
                <div v-bind:class="{ 'popin-content': true, 'loaded': isPopinLoaded }">
                    <template v-if="isPopinLoaded">
                        <span class="title">Bon cadeau {{ boncadeauComposition }} personne<span v-if="boncadeauComposition > 1">s</span></span>
                        <div class="popin-content-container bon_cadeau-infos" v-if="currentPopinName == 'boncadeau-infos'">
                            <div class="form-infos">
                                <div class="input-group">
                                    <div class="input-left">
                                        <span>Nom<span class="mandatory">*</span></span>
                                        <input type="text" v-model="formBonCadeauInfos_lastName" v-bind:class="formBonCadeauInfos_bindClass('formBonCadeauInfos_lastName')" />
                                    </div>
                                    <div class="input-right">
                                        <span>Raison sociale</span>
                                        <input type="text" v-model="formBonCadeauInfos_businessName" />
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-left">
                                        <span>Prénom<span class="mandatory">*</span></span>
                                        <input type="text" v-model="formBonCadeauInfos_firstName" v-bind:class="formBonCadeauInfos_bindClass('formBonCadeauInfos_firstName')" />
                                    </div>
                                    <div class="input-right">
                                        <span>Adresse</span>
                                        <input type="text" v-model="formBonCadeauInfos_address" />
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-left">
                                        <span>Téléphone<span class="mandatory">*</span></span>
                                        <input type="text" v-model="formBonCadeauInfos_phoneNumber" v-bind:class="formBonCadeauInfos_bindClass('formBonCadeauInfos_phoneNumber')" />
                                    </div>
                                    <div class="input-right">
                                        <span>Code postal</span>
                                        <input type="text" v-model="formBonCadeauInfos_zipCode" />
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-left">
                                        <span>E-mail acheteur<span class="mandatory">*</span></span>
                                        <input type="text" v-model="formBonCadeauInfos_emailFrom" v-bind:class="formBonCadeauInfos_bindClass('formBonCadeauInfos_emailFrom')" />
                                    </div>
                                    <div class="input-right">
                                        <span>Ville</span>
                                        <input type="text" v-model="formBonCadeauInfos_city" />
                                    </div>
                                </div>
                                <div class="input-self">
                                    <label for="form_isSendingSelected" class="checkbox-container multiple">
                                        Je souhaite envoyer le bon cadeau au destinataire de mon choix
                                        <span>Dans le cas contraire, je recevrai moi-même le bon cadeau à l'adresse e-mail indiquée</span>
                                        <input type="checkbox" id="form_isSendingSelected" name="form_isSendingSelected" v-model="formBonCadeauInfos_isSendingSelected">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="input-group" v-if="formBonCadeauInfos_isSendingSelected">
                                    <div class="input-left">
                                        <span>E-mail destinataire</span>
                                        <input type="text" v-model="formBonCadeauInfos_emailTo" v-bind:class="formBonCadeauInfos_bindClass('formBonCadeauInfos_emailTo')" />
                                    </div>
                                    <div class="input-right">
                                        <span>Envoyé le</span>
                                        <input type="text" placeholder="JJ/MM/AAAA" v-model="formBonCadeauInfos_sendingDate" v-bind:class="formBonCadeauInfos_bindClass('formBonCadeauInfos_sendingDate')" />
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-full">
                                        <span>Message <br/> personnalisé</span>
                                        <textarea v-model="formBonCadeauInfos_customMessage" />
                                    </div>
                                </div>
                                <div class="input-self">
                                    <label for="form_CGVChecked" class="checkbox-container">
                                        J'ai lu et j'accepte sans réserve les termes des C.G.V.<span class="mandatory">*</span>
                                        <input type="checkbox" id="form_CGVChecked" name="form_CGVChecked" v-model="formBonCadeauInfos_areTermsAgreed">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-submit">
                                    <span class="form-error">{{ formBonCadeauInfos_error }}</span>
                                    <button v-bind:disabled="!tarifs" v-on:click="payer_buttonClicked">
                                        <template v-if="tarifs">Payer {{ tarifs[boncadeauComposition] }}€ TTC</template>
                                        <template v-else>Payer</template>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="popin-content-container boncadeau-process" v-else-if="currentPopinName == 'boncadeau-process'">
                            <span v-html="boncadeauProcess_message"></span>

                            <form v-if="moneticoFields" method="post" target="_top" 
                                action="https://p.monetico-services.com/paiement.cgi" ref="moneticoForm">
                                <input type="hidden" name="ThreeDSecureChallenge" v-bind:value="moneticoFields.ThreeDSecureChallenge">
                                <input type="hidden" name="version" v-bind:value="moneticoFields.version">
                                <input type="hidden" name="TPE" v-bind:value="moneticoFields.TPE">
                                <input type="hidden" name="date" v-bind:value="moneticoFields.date">
                                <input type="hidden" name="montant" v-bind:value="moneticoFields.montant">
                                <input type="hidden" name="reference" v-bind:value="moneticoFields.reference">
                                <input type="hidden" name="MAC" v-bind:value="moneticoFields.MAC">
                                <input type="hidden" name="url_retour" v-bind:value="moneticoFields.url_retour">
                                <input type="hidden" name="url_retour_ok" v-bind:value="moneticoFields.url_retour_ok">
                                <input type="hidden" name="url_retour_err" v-bind:value="moneticoFields.url_retour_err">
                                <input type="hidden" name="lgue" v-bind:value="moneticoFields.lgue">
                                <input type="hidden" name="societe" v-bind:value="moneticoFields.societe">
                                <input type="hidden" name="contexte_commande" v-bind:value="moneticoFields.contexte_commande">
                                <input type="hidden" name="mail" v-bind:value="moneticoFields.mail">
                            </form>
                        </div>
                    </template>
                    <template v-else>
                        <Loader />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import Loader from './Loader.vue';

import anime from 'animejs/lib/anime.es';
import axios from 'axios';

export default {
    name: "BonCadeau",
    components: {
        Loader
    },
    data: () => ({
        // popin parameters
        isPopinDisplayed: false,
        isPopinLoaded: false,
        currentPopinName: 'boncadeau-infos',
        // bon cadeau informations
        boncadeauComposition: null,
        // reservation form parameters
        formBonCadeauInfos_lastName: null,
        formBonCadeauInfos_firstName: null,
        formBonCadeauInfos_phoneNumber: null,
        formBonCadeauInfos_emailFrom: null,
        formBonCadeauInfos_emailTo: null,
        formBonCadeauInfos_businessName: null,
        formBonCadeauInfos_address: null,
        formBonCadeauInfos_zipCode: null,
        formBonCadeauInfos_city: null,
        formBonCadeauInfos_isSendingSelected: false,
        formBonCadeauInfos_sendingDate: null,
        formBonCadeauInfos_customMessage: null,
        formBonCadeauInfos_areTermsAgreed: false,
        formBonCadeauInfos_isSubmit: false,
        formBonCadeauInfos_error: null,
        formBonCadeauInfos_errorFields: [],
        // tarifs informations
        tarifs: null,
        // reservation process
        boncadeauProcess_message: null
    }),
    props: {
        view_paymentDelayed: { type: Boolean, default: false }
    },
    methods: {
        performBonCadeau: function() {
            this.currentPopinName = 'boncadeau-process';
            this.boncadeauProcess_message = 'Merci de patienter pendant la création de votre bon cadeau...';

            var request_headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
            if (this.view_paymentDelayed) {
                let token = localStorage.getItem('admin-token');
                request_headers['Authorization'] = `Basic ` + token
            }

            axios.post('https://api.lockquest.fr/gift_card', {
                action: 'register',
                data: {
                    payment_delayed: this.view_paymentDelayed,
                    last_name: this.formBonCadeauInfos_lastName,
                    first_name: this.formBonCadeauInfos_firstName,
                    phone_number: this.formBonCadeauInfos_phoneNumber,
                    email_from: this.formBonCadeauInfos_emailFrom,
                    email_to: this.formBonCadeauInfos_emailTo,
                    business_name: this.formBonCadeauInfos_businessName,
                    address: this.formBonCadeauInfos_address,
                    zip_code: this.formBonCadeauInfos_zipCode,
                    city: this.formBonCadeauInfos_city,
                    sending_date: this.formBonCadeauInfos_sendingDate,
                    custom_message: this.formBonCadeauInfos_customMessage,
                    composition: this.boncadeauComposition
                }
            }, {
                headers: request_headers
            }).then((response) => {
                if (response.data) {
                    this.boncadeauProcess_message = 'Vous allez être rédirigé vers notre partenaire bancaire...';
                    this.moneticoFields = response.data;

                    var self = this;
                    setTimeout(function() {
                        self.$refs.moneticoForm.submit();
                    }, 1000);
                } else if (!this.view_paymentDelayed) {
                    this.boncadeauProcess_message = 'Une erreur est survenue, merci de contacter notre équipe.';
                } else {
                    this.boncadeauProcess_message = 'Le bon cadeau a été créé.';
                }
            }).catch((error) => {
                this.boncadeauProcess_message = 'Une erreur est survenue, merci de contacter notre équipe.';
            });
        },
        payer_buttonClicked: function(event) {
            this.formBonCadeauInfos_isSubmit = true;

            var errorFound = null;
            this.formBonCadeauInfos_errorFields = [];

            if (!this.formBonCadeauInfos_lastName) {
                this.formBonCadeauInfos_errorFields.push('formBonCadeauInfos_lastName');
                this.formBonCadeauInfos_bindClass('formBonCadeauInfos_lastName');
            }

            if (!this.formBonCadeauInfos_firstName) {
                this.formBonCadeauInfos_errorFields.push('formBonCadeauInfos_firstName');
                this.formBonCadeauInfos_bindClass('formBonCadeauInfos_firstName');
            }

            if (!this.formBonCadeauInfos_phoneNumber) {
                this.formBonCadeauInfos_errorFields.push('formBonCadeauInfos_phoneNumber');
                this.formBonCadeauInfos_bindClass('formBonCadeauInfos_phoneNumber');
            }

            if (!this.formBonCadeauInfos_emailFrom) {
                this.formBonCadeauInfos_errorFields.push('formBonCadeauInfos_emailFrom');
                this.formBonCadeauInfos_bindClass('formBonCadeauInfos_emailFrom');
            }

            if (this.formBonCadeauInfos_isSendingSelected) {
                if (!this.formBonCadeauInfos_emailTo) {
                    this.formBonCadeauInfos_errorFields.push('formBonCadeauInfos_emailTo');
                    this.formBonCadeauInfos_bindClass('formBonCadeauInfos_emailTo');
                }

                if (!this.formBonCadeauInfos_sendingDate) {
                    this.formBonCadeauInfos_errorFields.push('formBonCadeauInfos_sendingDate');
                    this.formBonCadeauInfos_bindClass('formBonCadeauInfos_sendingDate');
                }
            }

            if (this.formBonCadeauInfos_errorFields.length > 0) {
                errorFound = 'Veuillez remplir les champs indiqués en rouge avant de valider votre paiement';
            } else if (this.formBonCadeauInfos_isSendingSelected && !new RegExp(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/gm).test(this.formBonCadeauInfos_sendingDate)) {
                this.formBonCadeauInfos_errorFields.push('formBonCadeauInfos_sendingDate');
                this.formBonCadeauInfos_bindClass('formBonCadeauInfos_sendingDate');
                errorFound = 'La date d\'envoi du bon cadeau doit respecter le format JJ/MM/AAAA, par ex. 25/12/' + new Date().getFullYear();
            }

            if (errorFound) {
                this.formBonCadeauInfos_error = errorFound;
                return false;
            }

            if (this.formBonCadeauInfos_areTermsAgreed) {
                this.performBonCadeau();
            } else {
                this.formBonCadeauInfos_error = 'Vous devez accepter les C.G.V. avant de procéder au paiement de votre bon cadeau';
            }
        },
        formBonCadeauInfos_bindClass: function(form_dataField) {
            return { 'has-error': this.formBonCadeauInfos_errorFields.includes(form_dataField) };
        },
        popin_boncadeauDisplayed_callback(visible, entry) {
            if (!visible) {
                return;
            }

            this.isPopinLoaded = true;

            var self = this;
            Vue.nextTick(function() {
                axios
                    .get('https://api.lockquest.fr/tarifs/gift_cards')
                        .then((response) => {
                            self.tarifs = response.data;
                        })
                        .catch((error) => {

                        });
            });
        },
        popin_boncadeauDisplayed: function(composition) {
            this.boncadeauComposition = composition;
            this.isPopinDisplayed = true;
        },
        popin_boncadeauClosed: function(event) {
            this.isPopinDisplayed = false;
            this.isPopinLoaded = false;

            this.boncadeauComposition = null;
            this.currentPopinName = 'boncadeau-infos';

            this.formBonCadeauInfos_lastName = null;
            this.formBonCadeauInfos_firstName = null;
            this.formBonCadeauInfos_phoneNumber = null;
            this.formBonCadeauInfos_emailFrom = null;
            this.formBonCadeauInfos_emailTo = null;
            this.formBonCadeauInfos_businessName = null;
            this.formBonCadeauInfos_address = null;
            this.formBonCadeauInfos_zipCode = null;
            this.formBonCadeauInfos_city = null;
            this.formBonCadeauInfos_isSendingSelected = false;
            this.formBonCadeauInfos_sendingDate = null;
            this.formBonCadeauInfos_customMessage = null;
            this.formBonCadeauInfos_areTermsAgreed = false;
            this.formBonCadeauInfos_isSubmit = false;
            this.formBonCadeauInfos_error = null;
            this.formBonCadeauInfos_errorFields = [];

            this.boncadeauProcess_message = null;
        }
    }
}
</script>